module.exports = __webpack_public_path__ + "img/logo.a47aa766.svg";